// src/pages/FilingsPage.jsx
// SEC-FILINGS-PAGE — new file. Standalone route, own nav item (/filings).
//
// Shell only — owns view-toggle state, delegates fetching to useFilingsData
// and rendering to CategoryGrid/FilingFilters/FilingsFeed. Keep this file
// thin; any new capability goes in the hook or a component, not here.

import React, { useState } from 'react';
import { useFilingsData } from '../hooks/useFilingsData';
import CategoryGrid from '../components/filings/CategoryGrid';
import FilingFilters from '../components/filings/FilingFilters';
import FilingsFeed from '../components/filings/FilingsFeed';

export default function FilingsPage({ isLoggedIn, token, onRequestInvite, onSignIn, onNavigate }) {
  const [view, setView] = useState('browse'); // 'browse' | 'feed'

  const {
    categoryOverview, categoriesLoading, categoriesError,
    filters, setFilters, resetFilters,
    filings, total, pageSize, loading, error,
  } = useFilingsData({ token, includeCategories: true });

  const goToFeed = (patch) => { setFilters(patch); setView('feed'); };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        marginBottom: '1.25rem', flexWrap: 'wrap', gap: '0.75rem' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 900, color: '#f8fafc' }}>SEC Filings</h1>
          <div style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '0.2rem' }}>
            Live EDGAR filings, grouped and scored by significance.
          </div>
          <div style={{ fontSize: '0.68rem', color: '#475569', marginTop: '0.3rem' }}>
            * Showing our indexed filings, sorted by significance — not the complete SEC filing history.
          </div>
        </div>
        {view === 'feed' && (
          <button onClick={() => { setView('browse'); resetFilters(); }}
            style={{ padding: '0.5rem 1rem', background: 'none', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px', color: '#94a3b8', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'inherit' }}>
            ← Back to Categories
          </button>
        )}
      </div>

      {view === 'browse' && (
        <CategoryGrid
          overview={categoryOverview}
          loading={categoriesLoading}
          error={categoriesError}
          isLoggedIn={isLoggedIn}
          onSelectCategory={(cat) => goToFeed({ category: cat })}
          onApplyHighConviction={() => goToFeed({ preset: 'high_conviction', sort: 'significance' })}
          onSignIn={onSignIn}
        />
      )}

      {view === 'feed' && (
        <>
          <FilingFilters
            filters={filters}
            setFilters={setFilters}
            resetFilters={resetFilters}
            isLoggedIn={isLoggedIn}
            onSignIn={onSignIn}
          />
          <FilingsFeed
            filings={filings}
            total={total}
            page={filters.page}
            pageSize={pageSize}
            loading={loading}
            error={error}
            onPageChange={(p) => setFilters({ page: p })}
            onNavigate={onNavigate}
            onSignIn={onSignIn}
          />
        </>
      )}

      {!isLoggedIn && (
        <div style={{ marginTop: '2rem', padding: '1.25rem', background: 'rgba(0,212,255,0.04)',
          border: '1px solid rgba(0,212,255,0.12)', borderRadius: '12px', textAlign: 'center' }}>
          <div style={{ fontSize: '0.85rem', color: '#94a3b8', marginBottom: '0.75rem' }}>
            Sign in for form-type filters, significance sorting, high-conviction alerts, and Inner Circle filings.
          </div>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={onRequestInvite}
              style={{ padding: '0.6rem 1.15rem', background: 'transparent', border: '1px solid rgba(0,255,136,0.4)',
                borderRadius: '8px', color: '#00ff88', fontWeight: 700, cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'inherit' }}>
              Request Invite
            </button>
            <button onClick={onSignIn}
              style={{ padding: '0.6rem 1.15rem', background: 'linear-gradient(135deg,#00ff88,#00d4ff)',
                border: 'none', borderRadius: '8px', color: '#050d1a', fontWeight: 800, cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'inherit' }}>
              Sign In
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
